import axiosGraphQL from './GraphQL/axiosGraphQL';
import * as cnPlanQuery from './GraphQL/Queries/cnPlanQuery';
import {
  CNPLAN_VARIABLE,
  IGetTrackRevenueTeamSale,
  IGetTrackRevenueTeamSalesDetail,
} from './GraphQL/Variables/CNPlan';

const CNPlanApis = {
  getRevenuePlanTeamSale: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_ALL_REVENUE_PLAN_TEAMSALE,
      variables: CNPLAN_VARIABLE.getListCNPlan(params),
    });
  },
  createCNPlan: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.Create_Revenue_Plan_TeamSale,
      variables: CNPLAN_VARIABLE.createCNPlan(data),
    });
  },
  updateCNPlan: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.Update_Revenue_Plan_TeamSale,
      variables: CNPLAN_VARIABLE.updateHOPlan(data),
    });
  },
  importCNPlan: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.Import_Revenue_Plan_TeamSale,
      variables: CNPLAN_VARIABLE.importCNPlan(data),
    });
  },
  Check_Revenue_Plan_TeamSale_is_exist: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.Check_Revenue_Plan_TeamSale_is_exist,
      variables:
        CNPLAN_VARIABLE.Check_Revenue_Plan_TeamSale_is_exist_VARIABLE(data),
    });
  },
  getRevenueTeamsaleOfUser: async (input: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_REVENUE_TEAMSALE_OF_USER,
      variables: CNPLAN_VARIABLE.getRevenueTeamsaleOfUser(input),
    });
  },
  getRevenueTeamsaleByPlantIdYear: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_REVENUE_TEAMSALE_BY_PLANTID_YEAR,
      variables:
        CNPLAN_VARIABLE.GET_REVENUE_TEAMSALE_BY_PLANTID_YEAR_Variable(data),
    });
  },
  GetTypeRevenueComBoBox: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_TYPE_REVENUE_COMBOBOX,
      variables: CNPLAN_VARIABLE.GetTypeRevenueComBoBox(data),
    });
  },
  CheckExistedRevenueTeamSale: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.CHECK_EXISTED_REVENUE_TEAMSALE,
      variables: CNPLAN_VARIABLE.CheckExistedRevenueTeamSale(data),
    });
  },
  // get Track Revenue Team sales
  getTrackRevenueTeamSale: async (data: IGetTrackRevenueTeamSale) => {
    return await axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_TRACK_REVENUE_TEAMSALE,
      variables: CNPLAN_VARIABLE.getTrackRevenueTeamSale(data),
    });
  },
  getTrackRevenueTeamSalesDetail: async (
    data: IGetTrackRevenueTeamSalesDetail,
  ) => {
    return axiosGraphQL.post('/graphql', {
      query: cnPlanQuery.GET_TRACK_REVENUE_TEAMSALES_DETAIL,
      variables: CNPLAN_VARIABLE.getTrackRevenueTeamSalesDetail(data),
    });
  },
};

export default CNPlanApis;
